import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import PageList from '../../../components/PageListAPI'
import { journalTypesGetList, journalTypesDeleteById } from '../../../api/list'

export default function JournalTypesList() {
  const location = useLocation()
  const history = useHistory()
  return <div className='App-paper'>
    <PageList
      title='Типы журналов'
      name='journal_types-list'
      columns={[
        { id: 'createdAt', name: 'Дата создания', type: 'date', formatDate: 'LLL' },
        { id: 'categoryCode', name: 'Категория', width: 50 },
        { id: 'code', name: 'Код', width: 50 },
        { id: 'name', name: 'Наименование' },
        { id: 'gostRef', name: 'ГОСТ' },
        { id: 'isActual', name: 'Актуальный', type: 'component', component: ({ obj }) => <div>{obj.isActual ? 'Да' : 'Нет'}</div> },
        { id: 'tableNameData', name: 'Таблица данных' },
      ]}
      createItem={true}
      deleteItem={true}
      loadAPI={{
        request: journalTypesGetList,
      }}
      deleteAPI={journalTypesDeleteById}
      headerInit={{
        sortBy: 'createdAt',
        sortDirection: 'desc',
      }}
      location={location}
      history={history}
      click={false}
    />
  </div>
}